import { makeObservable, observable, toJS } from "mobx";

export class TreeStore {
  /** store类型 */
  storeType: string;
  /** 实体名称 */
  treename: string;
  /** 选中keys */
  selectedKeys: Array<string>;
  /** 勾选keys */
  checkedKeys: Array<string>
  /** 映射对照表 */
  keyMap: object;
  /** fields默认值 */
  fieldNames: object;
  /** 数据源 与keyMap联动 */
  treeData: Array<object>;
  /** 数据源 observable */
  dataSource: Array<object>;
  /** 根store */
  rootStore: any
  constructor(_storeMeta?: any, rootStore?: any) {
    this.storeType = 'TreeStore'
    this.treename = ''
    this.selectedKeys = [];
    this.checkedKeys = [];
    this.keyMap = {};
    this.treeData = [];
    this.dataSource = [];
    this.fieldNames = { title: 'name', key: 'id', children: 'children' }
    this.rootStore = rootStore
    makeObservable(this, {
      selectedKeys: observable,
      checkedKeys: observable,
      dataSource: observable
    })
  };

  getName() {
    return this.treename;
  }

  setName(name: string) {
    this.treename = name
  }

  getSelectedKeys() {
    return this.selectedKeys
  }

  getCheckedKeys() {
    return this.checkedKeys
  }

  findNodeByKey(data: Array<object>, id: string) {
    let result = null
    data.forEach(item => {
      if (item.id === id) {
        result = item;
        return;
      }
      if (item.children) {
        const found = this.findNodeByKey(item.children, id)
        if (found) {
          result = found
        }
      }
    })
    return result
  }

  getSelectedNodes() {
    const selectedKeys = this.getSelectedKeys()
    return selectedKeys.map(id => this.findNodeByKey(this.treeData, id))
  }

  getCheckedNodes() {
    const checkedKeys = this.getCheckedKeys()
    return checkedKeys.map(id => this.findNodeByKey(this.treeData, id))
  }

  updateTreeNode(data: object) {
    const keyMap = this.keyMap;
    keyMap[data.id] = Object.assign(keyMap[data.id], data);
    this.dataSource = this.treeData;
  }

  addTreeNode(id: string, data: object) {
    if (data.level > 5) {
      console.log('超出最大层级限制，不允许添加超过5级子级')
      return;
    }
    const keyMap = this.keyMap;
    const node = keyMap[id]
    if (node) {
      if (node.children) {
        node.children.unshift(data)
      } else {
        node.children = [data]
      }
    } else {
      this.treeData.push(data) // 未选中树，新建数据处理
    }
    keyMap[data.id] = data;
    this.dataSource = this.treeData
  }

  delTreeNode(data: object) {
    const keyMap = this.keyMap;
    const parentId = data.parent;
    const dataId = data.id;
    let curentIndex = 0
    if (parentId && parentId != dataId) {
      const parent = keyMap[parentId];
      parent.children = parent.children.filter((item, index) => {
        if (item.id !== data.id) {
          return item
        } else {
          curentIndex = index
        }
      })
      this.dataSource = this.treeData
    } else {
      let treeData = this.treeData;
      treeData = treeData.filter((item, index) => {
        if (item.id !== data.id) {
          return item
        } else {
          curentIndex = index
        }
      });
      this.dataSource = treeData
    }
    this.removeKeyMap(data)
    this.delAndSelectTreeNode(data, curentIndex)
  }

  // 删除节点后，选中另外一个节点。
  delAndSelectTreeNode(data: object, index: number) {
    const keyMap = this.keyMap;
    const parentId = data.parent;
    const dataId = data.id;
    let nextSelected
    if (parentId && parentId != dataId) {
      const parent = keyMap[parentId];
      nextSelected = parent.children.length ? (parent.children[index] || parent.children[index - 1]) : parent
    } else {
      const treeData = this.treeData;
      nextSelected = treeData.length ? (treeData[index] || treeData[index - 1]) : {}
    }

    if (nextSelected.id) {
      this.onSelect([nextSelected.id])
    }
  }

  removeKeyMap(data: object) {
    delete this.keyMap[data.id];
    if (data.children) {
      data.children.forEach(item => {
        this.removeKeyMap(item)
      })
    }
    if (!data.parent) {
      this.treeData = this.treeData.filter(item => item.id !== data.id)
    }
  }

  getValue() {
    return toJS(this.dataSource);
  }

  createKeyMap = (data: Array<object>) => {
    data?.forEach((item, index) => {
      this.keyMap[item.id] = data[index];
      if (item.children?.length) {
        this.createKeyMap(item.children, item.id)
      }
    })
  }

  setValue = (data: Array<object>) => {
    this.treeData = data
    this.createKeyMap(this.treeData);
    this.dataSource = data
  }

  clear() {
    this.keyMap = {};
    this.dataSource = [];
  }

  onSelect = (selectedKeys: Array<string>) => {
    this.selectedKeys = selectedKeys
  }

  onCheck = (checkedKeys: Array<string>) => {
    this.checkedKeys = checkedKeys
  }


  // addNode(key: string, node: object) {

  // }

  // addNodes(key: string, nodes: Array<object>) {

  // }

  // deleteNode(key: string) {

  // }

  // deleteNodes(keys: Array<string>) {

  // }

  // updateNode(key: string, node: object) {

  // }

  // updateNodes() {

  // }

  // getNodesByKeys(keys: Array<string>) {

  // }

  // getSelectedNodes() {

  // }

  // select() {

  // }

  // onExpand() {

  // }

  // loadSubLevelNodes() {

  // }

  // getParentNode() {

  // }
}